import { useLang } from "../contexts/LangContext";
import { team } from "../data/cases";
import FadeIn from "../components/FadeIn";

const Om = () => {
    const { t, lang } = useLang();

    const values = [
        { title: t.about.val1, text: t.about.val1Text },
        { title: t.about.val2, text: t.about.val2Text },
        { title: t.about.val3, text: t.about.val3Text },
        { title: t.about.val4, text: t.about.val4Text },
    ];

    return (
        <main data-testid="page-about" className="bg-white text-[#111111]">
            {/* Hero */}
            <section className="pt-40 md:pt-56 pb-20 md:pb-32">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6">
                    <FadeIn className="col-span-12 md:col-span-4">
                        <div className="text-[11px] tracking-luxury uppercase text-[#888]">
                            {t.about.eyebrow}
                        </div>
                    </FadeIn>
                    <FadeIn delay={0.1} className="col-span-12 md:col-span-8">
                        <h1 className="font-serif font-light text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight whitespace-pre-line">
                            {t.about.title}
                        </h1>
                        <p className="mt-10 max-w-xl text-base md:text-lg text-[#555] leading-relaxed">
                            {t.about.intro}
                        </p>
                    </FadeIn>
                </div>
            </section>

            {/* Founder */}
            <section className="bg-[#F9F8F6] py-24 md:py-32">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6 md:gap-12 items-start">
                    <FadeIn className="col-span-12 md:col-span-5">
                        <div className="aspect-[4/5] overflow-hidden bg-[#EBE8E3]">
                            <img
                                src={team[0].portrait}
                                alt={team[0].name}
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </FadeIn>
                    <FadeIn delay={0.1} className="col-span-12 md:col-span-6 md:col-start-7 md:mt-16">
                        <div className="text-[11px] tracking-luxury uppercase text-[#888] mb-6">
                            {t.about.founderLabel}
                        </div>
                        <blockquote className="font-serif italic font-light text-3xl md:text-5xl leading-[1.15] tracking-tight">
                            {t.about.founderQuote}
                        </blockquote>
                        <div className="mt-10">
                            <div className="font-serif text-xl md:text-2xl">
                                {t.about.founderName}
                            </div>
                            <div className="text-[11px] tracking-luxury uppercase text-[#888] mt-1">
                                {t.about.founderRole}
                            </div>
                        </div>
                    </FadeIn>
                </div>
            </section>

            {/* Team — hidden for now per client request */}
            {false && (
            <section className="py-24 md:py-32">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                    <FadeIn className="mb-16 md:mb-24 grid grid-cols-12 gap-6">
                        <div className="col-span-12 md:col-span-3">
                            <div className="text-[11px] tracking-luxury uppercase text-[#888]">
                                — {t.about.teamTitle}
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-9">
                            <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1] tracking-tight max-w-3xl">
                                {t.about.teamTitle}
                            </h2>
                            <p className="mt-6 max-w-xl text-sm md:text-base text-[#555] leading-relaxed">
                                {t.about.teamIntro}
                            </p>
                        </div>
                    </FadeIn>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-16">
                        {team.map((m, i) => (
                            <FadeIn
                                key={m.name}
                                delay={(i % 3) * 0.08}
                                data-testid={`team-member-${i}`}
                            >
                                <div className="aspect-[4/5] overflow-hidden bg-[#EBE8E3]">
                                    <img
                                        src={m.portrait}
                                        alt={m.name}
                                        className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000"
                                    />
                                </div>
                                <div className="mt-5">
                                    <div className="font-serif text-xl md:text-2xl">
                                        {m.name}
                                    </div>
                                    <div className="text-[11px] tracking-luxury uppercase text-[#888] mt-1">
                                        {lang === "da" ? m.roleDa : m.roleEn}
                                    </div>
                                </div>
                            </FadeIn>
                        ))}
                    </div>
                </div>
            </section>
            )}

            {/* Values */}
            <section className="border-t border-[#EAE8E4] py-24 md:py-32">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                    <FadeIn className="mb-16 md:mb-20">
                        <div className="text-[11px] tracking-luxury uppercase text-[#888] mb-3">
                            — Values
                        </div>
                        <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1] tracking-tight">
                            {t.about.valuesTitle}
                        </h2>
                    </FadeIn>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-x-8 gap-y-12">
                        {values.map((v, i) => (
                            <FadeIn key={i} delay={i * 0.06}>
                                <div className="border-t border-[#D9D4CD] pt-6">
                                    <div className="editorial-number text-base not-italic mb-3">
                                        0{i + 1}
                                    </div>
                                    <h3 className="font-serif text-2xl mb-3">
                                        {v.title}
                                    </h3>
                                    <p className="text-sm text-[#555] leading-relaxed">
                                        {v.text}
                                    </p>
                                </div>
                            </FadeIn>
                        ))}
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Om;
